// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var stringifyHelper = function stringifyHelper(data) {
  var jsonStringifiedData = JSON.stringify(data);
  return typeof data === 'string' || jsonStringifiedData === '{}' ? "".concat(data) : jsonStringifiedData;
};
//# sourceMappingURL=stringifyHelper.js.map